export default __webpack_public_path__ + "static/chunks/ui-assets/pattern-grid-white/69030076948467a3d0dcfdea22f32aea.webp";